export const SET_COMPANY_STATIONS = 'SET_COMPANY_STATIONS';

export const SET_DELETE = 'SET_DELETE';
export const CLEAR_DELETE = 'CLEAR_DELETE';
export const SET_DOC = 'SET_DOC';
export  const SET_SCREEN = 'SET_SCREEN';
